document.addEventListener("turbo:load", function() {
  $(".js-job-element").click(function () {
    $(".js-add-jobs").slideToggle();

		const arrowChange = $(this).find(".js-user-job-arrow");

		if (arrowChange.hasClass('user__arrow--right')) {
			arrowChange.addClass('user__arrow--down')
			arrowChange.removeClass('user__arrow--right')
		} else {
			arrowChange.removeClass('user__arrow--down')
			arrowChange.addClass('user__arrow--right')
		}

  });
});
